(() => {
  if (window.__fzLegalGuaranteeBound) return;
  window.__fzLegalGuaranteeBound = true;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-fz-guarantee-open]');
    if (opener) {
      const id = opener.getAttribute('aria-controls');
      const dialog = id ? document.getElementById(id) : null;
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      return;
    }

    const closer = event.target.closest('[data-fz-guarantee-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    if (event.target.matches('dialog.fz-legal-guarantee__dialog')) {
      event.target.close();
    }
  });
})();
